import { render } from "./datacalendar.vue?vue&type=template&id=d219460a"
import script from "./datacalendar.vue?vue&type=script&lang=js"
export * from "./datacalendar.vue?vue&type=script&lang=js"

import "./datacalendar.vue?vue&type=style&index=0&id=d219460a&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__